export function getElapsedTimeString(totalSeconds, onlyLongFormat: boolean) {
    // Pad the minutes and seconds with leading zeros, if required
    function addZero(num) {
        return (num < 10 ? '0' : '') + num;
    }
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds = totalSeconds % 3600;
    let minutes = Math.floor(totalSeconds / 60);
    totalSeconds = totalSeconds % 60;
    let seconds = Math.floor(totalSeconds);
    // Compose the string for display
    let currentTimeString = '';
    if (onlyLongFormat) {
        currentTimeString = addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds);
    } else if (hours === 0 && minutes === 0) {
        currentTimeString = addZero(seconds);
    } else if (hours === 0 && minutes > 0) {
        currentTimeString = addZero(minutes) + ':' + addZero(seconds);
    } else if (hours > 0 ) {
        currentTimeString = addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds);
    }
    return currentTimeString;
}
